module.exports = __webpack_public_path__ + "static/media/59e6ec989ff0b2041745837cbc159867.59e6ec98.webp";